import { types, getRoot } from 'mobx-state-tree';
import TagManager from 'react-gtm-module'

export default types.model("Analytics", {
    brand: types.optional(types.string, "Brand"),
    batchVariableName: "productImpressions"
}).views(self => ({
    get order() {
        return getRoot(self).order;
    },
    get navigation() {
        return getRoot(self).navigation;
    }
})).actions(self => {

    const isServer = (typeof window === 'undefined');
    
    
    return {
        
        afterCreate() {
            //console.log("analytics - afterCreate");
        },

        
        setCustomerType() {
            var tagManagerArgs = {
                'customer_type': self.navigation.isD2C ? "B2C" : "B2B",
                'event': "updateCustomerType"
            };

            console.debug("Datalayer - setCustomerType", tagManagerArgs, )
            if (typeof window !== "undefined")  {
                 window.dataLayer.push(tagManagerArgs);
            }
        },
        
        productImpression(product, listPosition) {
            if (!product || !listPosition) {
                return;
            }
            
            if (typeof window !== "undefined" && typeof window[self.batchVariableName] === 'undefined') {
                window.addEventListener('beforeunload', function () {
                    self.sendProductsImpressions(true);
                });
            }

            var productImpressions = window[self.batchVariableName] = window[self.batchVariableName] || [];
            productImpressions.push({
                'name': product.Name,
                'id': product.Sku,
                'list': self.navigation.pageContent.Title,
                'position': listPosition
            });
            self.sendProductsImpressions();

        },
        sendProductsImpressions(sendImpressions) {

            if (!sendImpressions) {
                sendImpressions = false;
            }

            var productImpressions = window[self.batchVariableName] = window[self.batchVariableName] || [];

            if (productImpressions.length > 49) {
                sendImpressions = true;
            }

            if (sendImpressions && productImpressions.length > 0) {
                var tagManagerArgs = {
                    'event': 'impressions',
                    'ecommerce': {
                        'impressions': productImpressions
                    }
                };
                console.debug("Datalayer - sendProductImpressions", tagManagerArgs)
                window.dataLayer.push(tagManagerArgs);
                window[self.batchVariableName] = [];
            }
        },
        productDetailView(product, primImage) {
            
            if (!product) {
                return;
            }

            var productSkus = [];

            if (product.Variants && product.Variants.length > 0) {
                product.Variants.map(v => {
                    productSkus.push(v.VariantSku);
                });
            }

            var tagManagerArgs = {
                'event': 'detail',
                'ecommerce': {
                    'currencyCode': product.CurrencyCode,
                    'detail': {
                        'actionField': {}, // Optional list property.
                        'products': [
                            {
                                'name': product.Name,
                                'id': product.Sku,
                                'price': "" + product.Price,
                                'listprice': "" + product.ListPrice,
                                'dimension1': 'Variants',
                                'image' : primImage,
                                'metric1': productSkus
                            }]
                    }
                }
            };
            console.debug("Datalayer - productDetailView", tagManagerArgs)
            window.dataLayer.push(tagManagerArgs);
        },
        productClick(product, listName, listPosition) {
            if (!product) {
                return;
            }
            var tagManagerArgs = {
                'event': 'productClick',
                'ecommerce': {
                    'currencyCode': product.CurrencyCode,
                    'click': {
                        'actionField': { 'list': listName }, // Optional list property.
                        'products': [
                            {
                                'name': product.Name,
                                'id': product.Sku,
                                'price': "" + product.Price,
                                'position': listPosition
                            }
                        ]
                    }
                }
            };

            console.debug("Datalayer - productClick", tagManagerArgs)
            window.dataLayer.push(tagManagerArgs);
        },
        addToCart(addEvent) {
            if (!addEvent) {
                return;
            }
            const tagManagerArgs = {
                'event': 'addToCart',
                'ecommerce': {
                    'currencyCode': addEvent.CurrencyCode,
                    'add': {
                        'products': [
                            {
                                'name': addEvent.ProductName,
                                'id': addEvent.Sku,
                                'price': "" + addEvent.PriceFloatingPoint,
                                'discount': "" + addEvent.DiscountFloatingPoint,
                                'variant': addEvent.VariantName,
                                'quantity': addEvent.Quantity,
                                'dimension1': 'VariantSku',
                                'checkoutUrl': self.navigation.mainTree.CheckoutUrl,
                                'metric1': addEvent.VariantSku
                            }
                        ]
                    }
                }
            };
            console.debug("Datalayer - addToCart", tagManagerArgs)
            window.dataLayer.push(tagManagerArgs);
        },
        removeFromCart(removeEvent) {
            if (!removeEvent) {
                return;
            }
            const tagManagerArgs = {
                'event': 'removeFromCart',
                'ecommerce': {
                    'currencyCode': removeEvent.Currency,
                    'remove': {
                        'products': [{
                            'name': removeEvent.ProductName,
                            'id': removeEvent.Sku,
                            'price': "" + removeEvent.PriceFloatingPoint,
                            'discount': "" + removeEvent.DiscountFloatingPoint,
                            'variant': removeEvent.VariantName,
                            'quantity': removeEvent.Quantity,
                            'dimension1': 'VariantSku',
                            'metric1': removeEvent.VariantSku
                        }]
                    }
                }
            };
            console.debug("Datalayer - removeFromCart", tagManagerArgs)
            window.dataLayer.push(tagManagerArgs);
        },
        checkout() {
            if (!self.order.activeOrder) { return; }
            var products = [];
            self.order.activeOrder.ProductList.map(p => {
                if (p.OrderLines && p.OrderLines.length > 0) {
                    p.OrderLines.map(orderLine => {
                        products.push({
                            'name': orderLine.ProductName,
                            'id': orderLine.Sku,
                            'price': "" + orderLine.Price,
                            //'brand': p.brand ? p.brand : this.brand,
                            //'category': null,
                            'variant': orderLine.VariantName,
                            'quantity': orderLine.Quantity,
                            'dimension1': 'VariantSku',
                            'metric1': orderLine.VariantSku

                        });
                    });
                }
            });

            const tagManagerArgs = {
                'event': 'checkout',
                'ecommerce': {
                    'checkout': {
                        //'actionField': { 'step': 1, 'option': 'Visa' },
                        'products': products
                    }
                }
            }

            console.debug("Datalayer - checkout", tagManagerArgs)
            window.dataLayer.push(tagManagerArgs);
        },
        purchase(order) {
            if (!order) { return; }

            //check if purchase already reported
            if (order.AdditionalData.GTMSynced) {
                return;
            }

            var products = [];
            order.ProductList.map(p => {
                if (p.OrderLines && p.OrderLines.length > 0) {
                    p.OrderLines.map(orderLine => {
                        products.push({
                            'name': orderLine.ProductName,
                            'id': orderLine.Sku,
                            'price': orderLine.Price,
                            'discount': orderLine.UnitDiscount,
                            'variant': orderLine.VariantName,
                            'quantity': orderLine.Quantity,
                            'dimension1': 'VariantSku',
                            'metric1': orderLine.VariantSku

                        });
                    });
                }
            });


            var vouchers = "";
            order.Vouchers.map((voucher, index) => {
                if (index > 0) {
                    vouchers += ",";
                }
                vouchers += voucher;
            });

            const tagManagerArgs = {
                'event': 'purchase',
                'ecommerce': {
                    'currencyCode': order.CurrencyCode,
                    'purchase': {
                        'actionField': {
                            'id': order.OrderNumber ? order.OrderNumber : order.OrderId,                         // Transaction ID. Required for purchases and refunds.
                            'affiliation': 'Online Store',
                            'revenue': "" + order.OrderTotal,                     // Total transaction value (incl. tax and shipping)
                            'tax': "" + order.TaxTotal,
                            'shipping': "" + order.ShippingTotal,
                            'coupon': vouchers
                        },
                        'products': products
                    }
                }
            }
            console.debug("Datalayer - purchase", tagManagerArgs)
            window.dataLayer.push(tagManagerArgs);
        }
    }
});